'use client';

import { useEffect } from 'react';

// exec async effect
// todo renturn handler
export function useAsyncEffect<T, U extends any[]>(method: () => Promise<T>, deps?: U) {
  useEffect(() => {
    (async () => {
      await method();
    })();
  }, deps);
}

export function sleep(time: number) {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve(true);
    }, time);
  });
}

export function batchRun(...promises: Promise<any>[]) {
  //等所有的 promise 都结束才返回，无论报错与否
  return new Promise((resolve) => {
    let count = 0;
    const len = promises.length;
    const result = new Array(len);
    promises.forEach((promise, index) => {
      promise
        .then((res) => {
          result[index] = res;
          count++;
          if (count === len) {
            resolve(result);
          }
        })
        .catch((err) => {
          result[index] = err;
          count++;
          if (count === len) {
            resolve(result);
          }
        });
    });
  });
}
